import React from 'react';
import Icon from './Icon';
import { ICONS } from './icon-map';
import './ds.css';

/** Empty state: icon, one-line title, one sentence of guidance, optional action. */
export default function EmptyState({ icon = ICONS.search, title = 'Nothing here yet', description, action, className = '' }) {
    return (
        <div className={`ds-empty ${className}`} role="status">
            <span className="ds-empty__icon"><Icon glyph={icon} size="md" /></span>
            <div className="ds-empty__title">{title}</div>
            {description && <div className="ds-empty__text">{description}</div>}
            {action && <div className="ds-empty__action">{action}</div>}
        </div>
    );
}

/** Skeleton block for loading states. */
export function Skeleton({ width = '100%', height = 12, className = '', style = {} }) {
    return <span className={`ds-skeleton ${className}`} style={{ width, height, ...style }} aria-hidden="true" />;
}
